// src/store/api/feedbackApi.js
import { baseApi } from './baseApi';

export const feedbackApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // Submit feedback (logged in or anonymous)
    submitFeedback: builder.mutation({
      query: (body) => ({
        url: '/Feedback',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Feedback'],
    }),

    // Get current user's own feedback + status
    getMyFeedback: builder.query({
      query: () => '/Feedback/my',
      providesTags: ['Feedback'],
      transformResponse: (res) => res?.$values ?? res ?? [],
    }),

  }),
});

export const {
  useSubmitFeedbackMutation,
  useGetMyFeedbackQuery,
} = feedbackApi;